import { BASE_URL, STATUSES_VALUES } from "./constants";
import { deleteAllCookies, setCookie } from '../utils/cookie';

// короткая форма
// const checkResponse = (res) => {
//   return res.ok
//     ? (res.status === 204 ? { success: 'ok' } : res.json())
//     : res.json().then((err) => Promise.reject(err));
// }

// const checkResponse = (res) => {
//   return res.ok ? (res.status === 204 ? { success: 'ok' } : res.json()) : res.json().then((err) => Promise.reject(err));
// }

// полная форма записи
const checkResponse = (res) => {
  if (res.ok) {
    return res.status === 204 ? { success: 'ok' } : res.json();
  } else {
    return res.json().then((err) => Promise.reject(err));
  }
}

export const postRefreshToken = (refreshToken) => {
  return fetch(`${BASE_URL}/api/auth/jwt/refresh/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      refresh: refreshToken,
    })
  })
    .then(checkResponse);
}

const fetchWithRefresh = async (
  endpoint, method, accessToken,
  refreshToken, data, file = false
) => {
  const options = {
    method: method,
    headers: {
      authorization: `Bearer ${accessToken}`
    }
  }

  if (!file) {
    options.headers["Content-Type"] = "application/json";
    options.body = JSON.stringify(data);
  } else {
    options.body = data;
  }

  try {
    const res = await fetch(`${BASE_URL}/api${endpoint}`, options);
    return await checkResponse(res);
  } catch (err) {
    if (err.code === "token_not_valid") {
      const refreshData = await postRefreshToken(refreshToken);
      if (!refreshData.access) {
        Promise.reject(refreshData)
      }
      deleteAllCookies();
      setCookie('accessToken', refreshData.access);
      if (options.headers) {
        options.headers.authorization = `Bearer ${refreshData.access}`;
      }
      const res = await fetch(`${BASE_URL}/api${endpoint}`, options);
      return await checkResponse(res);
    } else {
      return Promise.reject(err);
    }
  }
};


export const postRegister = (first_name, last_name, surname, phone, email, password) => {
  return fetch(`${BASE_URL}/api/auth/users/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ first_name, last_name, surname, phone, email, password })
  })
    .then(checkResponse);
}

export const postQuickRegister = (first_name, last_name, surname, email, phone) => {
  return fetch(`${BASE_URL}/api/users/quick_register/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ first_name, last_name, surname, email, phone })
  })
    .then(checkResponse);
}

export const postLogin = (password, email) => {
  return fetch(`${BASE_URL}/api/auth/jwt/create`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password })
  })
    .then(checkResponse);
}

export const getSettingsRequest = () => {
  return fetch(`${BASE_URL}/api/settings/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getCategoriesRequest = () => {
  return fetch(`${BASE_URL}/api/categories/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getContacts_phones = () => {
  return fetch(`${BASE_URL}/api/contacts/phones/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getContacts_emails = () => {
  return fetch(`${BASE_URL}/api/contacts/emails/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getContacts_socials = () => {
  return fetch(`${BASE_URL}/api/contacts/socials/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getProductsAuth = async (accessToken, refreshToken) => {
  const res = await fetchWithRefresh(`/products/`, 'GET', accessToken, refreshToken);
  return await res;
}

export const getProducts = () => {
  return fetch(`${BASE_URL}/api/products/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getListShippings = () => {
  return fetch(`${BASE_URL}/api/shippings/`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getListNews = (type = '', page = 1) => {
  let params = new URLSearchParams({
  });

  if (type === 'news' || type === 'articles') {
    params.append('type', type);
  }
  if (page > 0) {
    params.append('page', page);
  }

  params = params.toString();

  return fetch(`${BASE_URL}/api/news/?${params}`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const getOneNews = (slug) => {
  return fetch(`${BASE_URL}/api/news/${slug}`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then(checkResponse);
}

export const postActivation = (uid, token) => {
  return fetch(`${BASE_URL}/api/auth/users/activation/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ uid, token })
  })
    .then(checkResponse);
}

// запрос на ссылку для активации, если первую потеряли
export const postResendActivation = (email) => {
  return fetch(`${BASE_URL}/api/auth/users/resend_activation/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email })
  })
    .then(checkResponse);
}

export const postPasswordResetConfirm = (uid, token, new_password, re_new_password) => {
  return fetch(`${BASE_URL}/api/auth/users/reset_password_confirm/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ uid, token, new_password, re_new_password })
  })
    .then(checkResponse);
}


export const getMe = async (accessToken, refreshToken) => {
  const res = await fetchWithRefresh('/auth/users/me', 'GET', accessToken, refreshToken);
  return await res;
}

export const patchMe = async (
  accessToken, refreshToken, data
) => {
  const res = await fetchWithRefresh('/auth/users/me/', 'PATCH', accessToken, refreshToken, data);
  return await res;
}
export const deleteMe = async (
  accessToken, refreshToken, data
) => {
  const res = await fetchWithRefresh('/auth/users/me/', 'DELETE', accessToken, refreshToken, data);
  return await res;
}

export const syncCart = async (
  accessToken, refreshToken, method, cart
) => (
  await fetchWithRefresh('/cart/', method, accessToken, refreshToken, cart)
)

export const clearCart = async (
  accessToken, refreshToken
) => (
  await fetchWithRefresh('/cart/', 'DELETE', accessToken, refreshToken)
)


export const postResetPassword = (email) => {
  return fetch(`${BASE_URL}/api/auth/users/reset_password/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email })
  })
    .then(checkResponse);
}

export const postSetPassword = async (accessToken, refreshToken, data
) => {
  const res = await fetchWithRefresh(
    '/auth/users/set_password/', 'POST', accessToken, refreshToken, data
  );
  return await res;
}
export const postSetEmail = async (accessToken, refreshToken, data
) => {
  const res = await fetchWithRefresh(
    '/auth/users/set_email/', 'POST', accessToken, refreshToken, data
  );
  return await res;
}

export const getOrders = async (
  accessToken, refreshToken, page = 0, user_id = -1, status = '', year = '', firm_id = '', payment_status = ''
) => {
  let params = new URLSearchParams({});

  if (page > 0) params.append('page', page);
  if (user_id >= 0) params.append('user_id', user_id);
  if (
    status === STATUSES_VALUES.created ||
    status === STATUSES_VALUES.invoiced ||
    status === STATUSES_VALUES.delivery ||
    status === STATUSES_VALUES.await_receipt ||
    status === STATUSES_VALUES.received ||
    status === STATUSES_VALUES.cancelled
  ) params.append('status', status);
  if (
    parseInt(year) >= 2024
  ) params.append('year', year);
  if (firm_id && parseInt(firm_id) >= -1) params.append('firm_id', firm_id);
  if (payment_status) params.append('payment_status', payment_status);

  params = params.toString();
  const res = await fetchWithRefresh(`/orders/?${params}`, 'GET', accessToken, refreshToken);
  return await res;
}




export const createOrderNoActive = (data) => {
  return fetch(`${BASE_URL}/api/orders/create_no_active/`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...data })
  })
    .then(checkResponse);
}

export const createOrder = async (accessToken, refreshToken, data) => {
  const res = await fetchWithRefresh('/orders/', 'POST', accessToken, refreshToken, data);
  return await res;
}

export const patchOrder = async (accessToken, refreshToken, id, data) => {
  const res = await fetchWithRefresh(`/orders/${id}/`, 'PATCH', accessToken, refreshToken, data);
  return await res;
}

export const getOrder = async (accessToken, refreshToken, id) => {
  const res = await fetchWithRefresh(`/orders/${id}/`, 'GET', accessToken, refreshToken);
  return await res;
}

export const getFirms = async (accessToken, refreshToken, user_id = null) => {

  let params = new URLSearchParams({});

  if (user_id) {
    params.append('user_id', user_id);
  }
  params = params.toString();

  const res = await fetchWithRefresh(`/firms/?${params}`, 'GET', accessToken, refreshToken);
  return await res;
}


export const createFirm = async (accessToken, refreshToken, data, user_id) => {
  let params = new URLSearchParams({});

  if (user_id) {
    params.append('user_id', user_id);
  }
  params = params.toString();
  const res = await fetchWithRefresh(`/firms/?${params}`, 'POST', accessToken, refreshToken, data);
  return await res;
}

export const getFirm = async (accessToken, refreshToken, inn) => {
  const res = await fetchWithRefresh(`/firms/${inn}/`, 'GET', accessToken, refreshToken);
  return await res;
}

export const removeFirm = async (accessToken, refreshToken, inn, user_id) => {
  let params = new URLSearchParams({});

  if (user_id) {
    params.append('user_id', user_id);
  }
  params = params.toString();
  const res = await fetchWithRefresh(`/firms/${inn}/?${params}`, 'DELETE', accessToken, refreshToken);
  return await res;
}

export const addFirm = async (accessToken, refreshToken, inn, user_id) => {
  let params = new URLSearchParams({});

  if (user_id) {
    params.append('user_id', user_id);
  }
  params = params.toString();
  const res = await fetchWithRefresh(`/firms/${inn}/?${params}`, 'POST', accessToken, refreshToken);
  return await res;
}

export const getFav = async (accessToken, refreshToken) => (
  await fetchWithRefresh('/favorites/', 'GET', accessToken, refreshToken)
)

export const addFav = async (accessToken, refreshToken, data) => {
  const res = await fetchWithRefresh('/favorites/', 'POST', accessToken, refreshToken, data);
  return await res;
}

export const removeFav = async (accessToken, refreshToken, data) => {
  const res = await fetchWithRefresh('/favorites/', 'DELETE', accessToken, refreshToken, data);
  return await res;
}




// const checkFileDownloadResponse = (res, name) => {
//   return new Promise((resolve, reject) => {
//     if (res.status < 400) {
//       return res.blob().then(blob => {
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = name;
//         document.body.appendChild(a);
//         a.click();
//         a.remove();
//       })
//       .catch(reject)
//     }
//     reject()
//     // res.end();
//   })
// }

// export const getBill = (accessToken, refreshToken, id, name) => {
//   return fetch(
//     `${BASE_URL}/api/orders/${id}/download-bill/`,
//     {
//       method: 'GET',
//       headers: {
//         "Content-Type": "application/json",
//         authorization: `Bearer ${accessToken}`,
//       },
//     }
//   ).then(res => checkFileDownloadResponse(res, name))
// }


// const refreshAccessToken = async (refreshToken) => {
//   try {
//     const res = await fetch(`${BASE_URL}/api/auth/refresh/`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ refresh: refreshToken }),
//     });

//     if (!res.ok) {
//       throw new Error("Failed to refresh access token");
//     }

//     const data = await res.json();
//     document.cookie = `accessToken=${data.access}; path=/`; // Сохраняем новый токен
//     return data.access;
//   } catch (error) {
//     console.error("Error refreshing token:", error);
//     throw error;
//   }
// };

// const checkFileDownloadResponse = (res, name) => {
//   return new Promise((resolve, reject) => {
//     if (res.status < 400) {
//       return res.blob().then((blob) => {
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = name;
//         document.body.appendChild(a);
//         a.click();
//         a.remove();
//         window.URL.revokeObjectURL(url); // Очищаем память
//         resolve();
//       }).catch(reject);
//     }
//     reject(new Error(`Download failed with status ${res.status}`));
//   });
// };

// export const getBill = async (accessToken, refreshToken, id, name, isRetry = false) => {
//   try {
//     const res = await fetch(`${BASE_URL}/api/orders/${id}/download-bill/`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         authorization: `Bearer ${accessToken}`,
//       },
//     });

//     if (res.status === 401 && !isRetry) {
//       console.warn("Access token expired. Trying to refresh...");
//       // const newAccessToken = await refreshAccessToken(refreshToken);
//       const newAccessToken = await postRefreshToken(refreshToken);
//       return getBill(newAccessToken, refreshToken, id, name, true);
//     }

//     if (!res.ok) {
//       throw new Error(`HTTP error! Status: ${res.status}`);
//     }

//     await checkFileDownloadResponse(res, name);
//   } catch (error) {
//     console.error("Error downloading bill:", error);
//     throw error;
//   }
// };


// export const getInvoice = (accessToken, refreshToken, id, name) => {
//   return fetch(
//     `${BASE_URL}/api/orders/${id}/download-invoice/`,
//     {
//       method: 'GET',
//       headers: {
//         "Content-Type": "application/json",
//         authorization: `Bearer ${accessToken}`,
//       },
//     }
//   ).then(res => checkFileDownloadResponse(res, name))
// }

// не работает обновление токена, если он просрочен
const fetchDownloadWithRefresh = async (
  endpoint, accessToken,
  refreshToken, name
) => {
  const options = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${accessToken}`
    },
  }
  try {
    const res = await fetch(`${BASE_URL}/api${endpoint}`, options);
    if (res.ok) {
      return res.blob().then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url); // Очищаем память
      });
    } else {
      return Promise.reject('');
    }
  } catch (err) {
    if (err.code === "token_not_valid") {
      const refreshData = await postRefreshToken(refreshToken);
      if (!refreshData.access) {
        Promise.reject(refreshData)
      }
      deleteAllCookies();
      setCookie('accessToken', refreshData.access);
      if (options.headers) {
        options.headers.authorization = `Bearer ${refreshData.access}`;
      }
      const res = await fetch(`${BASE_URL}/api${endpoint}`, options);
      return await checkResponse(res);
    } else {
      return Promise.reject(err);
    }
  }
};

export const getBill = async (accessToken, refreshToken, id, name) => {
  const res = await fetchDownloadWithRefresh(
    `/orders/${id}/download_bill/`, accessToken, refreshToken, name
  );
  return await res;
}

export const getInvoice = async (accessToken, refreshToken, id, name) => {
  const res = await fetchDownloadWithRefresh(
    `/orders/${id}/download_invoice/`, accessToken, refreshToken, name
  );
  return await res;
}

export const getBillOfLading = async (accessToken, refreshToken, id, name) => {
  const res = await fetchDownloadWithRefresh(
    `/orders/${id}/download_bill_of_lading/`, accessToken, refreshToken, name
  );
  return await res;
}

export const patchMakeInvoiced = async (accessToken, refreshToken, id) => {
  const res = await fetchWithRefresh(`/orders/${id}/make_invoiced/`, 'PATCH', accessToken, refreshToken);
  return await res;
}

export const patchMakeCancelled = async (accessToken, refreshToken, id) => {
  const res = await fetchWithRefresh(`/orders/${id}/make_cancelled/`, 'PATCH', accessToken, refreshToken);
  return await res;
}

export const getUsers = async (accessToken, refreshToken, last_name) => {
  let params = new URLSearchParams({});

  if (last_name) {
    params.append('last_name', last_name);
  }
  params = params.toString();

  const res = await fetchWithRefresh(`/users/?${params}`, 'GET', accessToken, refreshToken);
  return await res;
}

export const patchRequestBill = async (accessToken, refreshToken, id) => {
  const res = await fetchWithRefresh(`/orders/${id}/request_bill/`, 'PATCH', accessToken, refreshToken);
  return await res;
}

export const patchUploadOrderFile = async (accessToken, refreshToken, id, data, docType) => {
  const res = await fetchWithRefresh(
    `/orders/${id}/upload_${docType}/`, 'PATCH', accessToken, refreshToken, data, true);
  return await res;
}

export const patchRequestInvoice = async (accessToken, refreshToken, id) => {
  const res = await fetchWithRefresh(`/orders/${id}/request_invoice/`, 'PATCH', accessToken, refreshToken);
  return await res;
}

export const patchRequestAddPay = async (accessToken, refreshToken, id, data) => {
  const res = await fetchWithRefresh(`/orders/${id}/add_pay/`, 'PATCH', accessToken, refreshToken, data);
  return await res;
}

export const patchRequestSetDefPayment = async (accessToken, refreshToken, id, data) => {
  const res = await fetchWithRefresh(`/orders/${id}/set_def_payment/`, 'PATCH', accessToken, refreshToken, data);
  return await res;
}

export const patchMakeAwaitReceipt = async (accessToken, refreshToken, id) => {
  const res = await fetchWithRefresh(`/orders/${id}/make_await_receipt/`, 'PATCH', accessToken, refreshToken);
  return await res;
}

export const patchMakeReceived = async (accessToken, refreshToken, id) => {
  const res = await fetchWithRefresh(`/orders/${id}/make_received/`, 'PATCH', accessToken, refreshToken);
  return await res;
}
